// Comprehensive Sugar Catalogue Data for SPANXPORT

export const sugarData = [
  {
    id: "icumsa-45",
    name: "ICUMSA 45 White Refined Sugar",
    grade: "Premium Export Grade",
    icumsaValue: "Max 45 IU",
    category: "refined",
    image: "icumsa-45",
    description: "ICUMSA 45 is the highest quality refined white sugar available in the international market. Named after the International Commission for Uniform Methods of Sugar Analysis, this premium grade has an ICUMSA rating below 45, indicating exceptional purity and whiteness. It's the preferred choice for direct consumption and premium applications.",
    processing: "Produced through multiple stages of refining including affination, carbonatation, filtration, and crystallization. The sugar undergoes rigorous purification to remove impurities, color bodies, and ash content, resulting in pure white crystals with minimal color.",
    applications: "Premium food and beverage manufacturing, confectionery, pharmaceutical preparations, direct consumption, carbonated drinks, high-end bakery products, and applications requiring the whitest sugar with neutral flavor.",
    specifications: {
      polarization: "Min 99.80%",
      moisture: "Max 0.04%",
      ash: "Max 0.04%",
      color: "Max 45 ICUMSA",
      granulation: "0.5-1.0 mm",
      sulphurDioxide: "Max 20 ppm"
    },
    packaging: "25kg/50kg PP bags, 1MT jumbo bags, bulk shipments",
    shelfLife: "24 months in proper storage conditions",
    origin: "India - Maharashtra, Uttar Pradesh, Karnataka",
    certifications: "FSSAI, ISO 22000, HACCP, Kosher, Halal available"
  },
  {
    id: "icumsa-100",
    name: "ICUMSA 100 Refined Sugar",
    grade: "Standard Export Grade",
    icumsaValue: "Max 100 IU",
    category: "refined",
    image: "icumsa-100",
    description: "ICUMSA 100 is a high-quality refined white sugar suitable for most industrial and food processing applications. With slightly higher color than ICUMSA 45, it offers excellent value while maintaining high purity standards. Widely used in food manufacturing where ultra-white color is not critical.",
    processing: "Refined through standard sugar refining processes including clarification, decolorization, and crystallization. The process removes most impurities while retaining excellent sweetening properties and neutral flavor.",
    applications: "Beverage manufacturing, bakery products, food processing, ice cream, dairy products, canned foods, and general industrial food applications where cost-efficiency is important.",
    specifications: {
      polarization: "Min 99.70%",
      moisture: "Max 0.06%",
      ash: "Max 0.06%",
      color: "Max 100 ICUMSA",
      granulation: "0.5-1.2 mm",
      sulphurDioxide: "Max 30 ppm"
    },
    packaging: "25kg/50kg PP bags, 1MT jumbo bags, bulk shipments",
    shelfLife: "24 months in proper storage conditions",
    origin: "India - Multiple states",
    certifications: "FSSAI, ISO 22000, HACCP"
  },
  {
    id: "icumsa-150",
    name: "ICUMSA 150 Refined Sugar",
    grade: "Industrial Grade",
    icumsaValue: "Max 150 IU",
    category: "refined",
    image: "icumsa-150",
    description: "ICUMSA 150 refined sugar is an economical option for industrial food processing where high-grade whiteness is not essential. It maintains good purity and sweetening characteristics while offering significant cost advantages for bulk applications.",
    processing: "Standard refining process with less intensive decolorization. Suitable for applications where the sugar will be further processed or where color is masked by other ingredients.",
    applications: "Industrial food processing, fermentation industries, confectionery manufacturing, bakery ingredients, and applications where sugar color is not visible in the final product.",
    specifications: {
      polarization: "Min 99.60%",
      moisture: "Max 0.08%",
      ash: "Max 0.10%",
      color: "Max 150 ICUMSA",
      granulation: "0.5-1.5 mm",
      sulphurDioxide: "Max 50 ppm"
    },
    packaging: "50kg PP bags, 1MT jumbo bags, bulk",
    shelfLife: "24 months",
    origin: "India",
    certifications: "FSSAI, ISO 22000"
  },
  {
    id: "raw-sugar",
    name: "Raw Cane Sugar (VHP)",
    grade: "Very High Polarization",
    icumsaValue: "600-1200 IU",
    category: "raw",
    image: "raw-sugar",
    description: "Very High Polarization (VHP) raw sugar is minimally processed cane sugar intended for further refining. It retains more of the natural molasses content, giving it a golden-brown color. VHP sugar is the standard grade traded in international commodity markets.",
    processing: "Produced directly from sugarcane juice through clarification, evaporation, and crystallization. The sugar is centrifuged to remove excess molasses but not refined, preserving its natural characteristics.",
    applications: "Raw material for sugar refineries, industrial fermentation, ethanol production, animal feed supplements, and specialty food products requiring natural cane flavor.",
    specifications: {
      polarization: "Min 99.30%",
      moisture: "Max 0.15%",
      ash: "Max 0.15%",
      color: "600-1200 ICUMSA",
      granulation: "Variable",
      reducingSugars: "Max 0.10%"
    },
    packaging: "50kg jute/PP bags, bulk shipments",
    shelfLife: "18 months",
    origin: "India - Sugar mill direct",
    certifications: "FSSAI"
  },
  {
    id: "plantation-white",
    name: "Plantation White Sugar",
    grade: "Mill White",
    icumsaValue: "150-400 IU",
    category: "plantation",
    image: "plantation-white",
    description: "Plantation white sugar, also known as mill white or direct consumption sugar, is produced directly at sugar mills without the need for a separate refinery. It has an off-white to light cream color and is widely used in countries where refined white sugar is not required.",
    processing: "Produced through sulphitation or carbonation process at sugar mills. The juice is clarified using lime and either sulphur dioxide or carbon dioxide, then crystallized to produce white sugar directly.",
    applications: "Direct household consumption, local food industries, bakeries, beverages, and markets where plantation white is the standard grade.",
    specifications: {
      polarization: "Min 99.50%",
      moisture: "Max 0.10%",
      ash: "Max 0.10%",
      color: "150-400 ICUMSA",
      granulation: "0.6-1.2 mm",
      sulphurDioxide: "Max 70 ppm (S-process)"
    },
    packaging: "50kg jute/PP bags, 25kg consumer packs",
    shelfLife: "18 months",
    origin: "India - Sugar mills",
    certifications: "FSSAI"
  },
  {
    id: "brown-sugar",
    name: "Natural Brown Sugar",
    grade: "Specialty",
    icumsaValue: "1500-4000 IU",
    category: "specialty",
    image: "brown-sugar",
    description: "Natural brown sugar retains some of the original molasses from the sugar cane, giving it a distinctive brown color, moist texture, and rich caramel-like flavor. It's valued in baking and specialty applications for its unique taste profile.",
    processing: "Produced by partially refining cane sugar or by adding molasses back to refined sugar. Natural brown sugar is less processed, retaining more of the cane's natural characteristics.",
    applications: "Specialty baking (cookies, cakes, brownies), barbecue sauces, marinades, coffee sweetening, premium food products, and recipes requiring caramel notes.",
    specifications: {
      polarization: "Min 96.00%",
      moisture: "1.5-3.5%",
      ash: "Max 0.50%",
      color: "1500-4000 ICUMSA",
      molassesContent: "3.5-6.5%",
      granulation: "Variable"
    },
    packaging: "25kg bags, 1kg/500g retail packs",
    shelfLife: "18 months",
    origin: "India",
    certifications: "FSSAI, Organic available"
  },
  {
    id: "demerara-sugar",
    name: "Demerara Sugar",
    grade: "Specialty",
    icumsaValue: "1000-3000 IU",
    category: "specialty",
    image: "demerara-sugar",
    description: "Demerara sugar features large, golden crystals with a subtle molasses flavor and satisfying crunch. Named after the Demerara colony in Guyana, this specialty sugar is prized for its distinctive texture and is a favorite for sweetening coffee and topping desserts.",
    processing: "Produced from the first crystallization of cane juice with minimal processing. The large crystals are formed through controlled crystallization, retaining natural molasses coating.",
    applications: "Coffee and tea sweetening, crumble toppings, premium baked goods, cocktails, decorative sugar application, and anywhere a crunchy texture is desired.",
    specifications: {
      polarization: "Min 97.00%",
      moisture: "Max 1.0%",
      ash: "Max 0.30%",
      color: "1000-3000 ICUMSA",
      crystalSize: "1.5-3.0 mm (large)",
      molassesContent: "1-2%"
    },
    packaging: "25kg bags, retail packs",
    shelfLife: "24 months",
    origin: "India",
    certifications: "FSSAI"
  },
  {
    id: "muscovado",
    name: "Muscovado Sugar",
    grade: "Artisan/Unrefined",
    icumsaValue: "3000-6000 IU",
    category: "specialty",
    image: "muscovado-sugar",
    description: "Muscovado is a type of unrefined cane sugar with a strong molasses content and flavor. It has a dark brown color, moist and sticky texture, and deep, complex flavor with notes of toffee and licorice. Highly valued in artisan baking.",
    processing: "Produced through traditional methods with minimal processing. Cane juice is heated and evaporated, then crystallized without removing molasses. May be produced through open pan methods.",
    applications: "Artisan baking, gingerbread, dark fruit cakes, toffee, caramel sauces, Asian cuisine, and recipes requiring deep, complex sweetness.",
    specifications: {
      polarization: "Min 93.00%",
      moisture: "2.0-4.0%",
      ash: "Max 1.50%",
      color: "3000-6000 ICUMSA",
      molassesContent: "8-12%",
      texture: "Moist, sticky"
    },
    packaging: "25kg bags, retail packs",
    shelfLife: "18 months",
    origin: "India",
    certifications: "FSSAI, Organic available"
  },
  {
    id: "jaggery-powder",
    name: "Jaggery (Gur) Powder",
    grade: "Traditional Unrefined",
    icumsaValue: "N/A",
    category: "traditional",
    image: "jaggery-powder",
    description: "Jaggery, known as 'Gur' in India, is a traditional unrefined sugar made from sugarcane juice or palm sap. It retains all natural minerals and is considered healthier than refined sugar. Jaggery powder is the granulated form for easy use.",
    processing: "Sugarcane juice is extracted, clarified naturally, and boiled in large vessels until it thickens. The concentrated liquid is cooled and solidified, then ground into powder form.",
    applications: "Traditional Indian sweets (ladoo, chikki), Ayurvedic preparations, natural sweetener, tea and coffee, marinades, and health-conscious consumers seeking unrefined alternatives.",
    specifications: {
      sucrose: "65-85%",
      moisture: "Max 5.0%",
      reducingSugars: "10-15%",
      minerals: "Iron, calcium, potassium",
      color: "Golden to dark brown",
      form: "Powder/Granules"
    },
    packaging: "25kg bags, 1kg/500g retail packs",
    shelfLife: "12 months",
    origin: "India - Maharashtra, Tamil Nadu, Andhra Pradesh",
    certifications: "FSSAI, Organic available"
  },
  {
    id: "jaggery-blocks",
    name: "Jaggery Blocks (Gur)",
    grade: "Traditional Unrefined",
    icumsaValue: "N/A",
    category: "traditional",
    image: "jaggery-blocks",
    description: "Traditional jaggery in solid block form, made by pouring concentrated sugarcane juice into molds. These blocks are the most common form of jaggery in India and are valued for their rich flavor and mineral content.",
    processing: "Fresh sugarcane juice is boiled and reduced to a thick consistency, then poured into molds of various sizes. The blocks are cooled and dried naturally.",
    applications: "Traditional cooking, religious offerings, sweet preparations, direct consumption, tea sweetening in rural areas, and export to diaspora markets.",
    specifications: {
      sucrose: "65-85%",
      moisture: "Max 8.0%",
      reducingSugars: "10-15%",
      minerals: "Iron, calcium, magnesium",
      color: "Light to dark brown",
      form: "250g-1kg blocks"
    },
    packaging: "Wrapped blocks in cartons, bulk",
    shelfLife: "12 months",
    origin: "India",
    certifications: "FSSAI, Organic available"
  },
  {
    id: "palm-jaggery",
    name: "Palm Jaggery (Karupatti)",
    grade: "Premium Traditional",
    icumsaValue: "N/A",
    category: "traditional",
    image: "palm-jaggery",
    description: "Palm jaggery is made from the sap of various palm trees, particularly palmyra, date palm, and coconut palm. It has a distinctively different flavor from cane jaggery with complex sweet and slightly salty notes. Considered a healthier alternative.",
    processing: "Fresh palm sap is collected from tapped palm trees, filtered, and boiled to concentrate. The thickened sap is poured into molds and allowed to solidify into blocks or discs.",
    applications: "Traditional South Indian sweets, Ayurvedic medicine, natural sweetener for diabetic-friendly recipes (lower glycemic index), and premium food applications.",
    specifications: {
      sucrose: "50-70%",
      moisture: "Max 6.0%",
      reducingSugars: "15-25%",
      minerals: "Rich in B vitamins, iron",
      glycemicIndex: "Lower than cane sugar",
      form: "Discs or blocks"
    },
    packaging: "Retail packs, bulk cartons",
    shelfLife: "12 months",
    origin: "India - Tamil Nadu, Andhra Pradesh, Kerala",
    certifications: "FSSAI, Organic available"
  },
  {
    id: "caster-sugar",
    name: "Caster Sugar (Superfine)",
    grade: "Specialty Fine",
    icumsaValue: "Max 45 IU",
    category: "refined",
    image: "caster-sugar",
    description: "Caster sugar, also known as superfine sugar, has a very fine granulation that dissolves quickly. The small crystal size makes it ideal for baking applications where smooth texture is essential, particularly meringues and delicate cakes.",
    processing: "Produced by grinding refined white sugar to achieve fine, uniform crystals. The sugar undergoes size classification to ensure consistent granulation.",
    applications: "Meringues, soufflés, delicate sponge cakes, cocktails, icing, whipped cream sweetening, and any application requiring quick dissolution.",
    specifications: {
      polarization: "Min 99.80%",
      moisture: "Max 0.04%",
      ash: "Max 0.04%",
      color: "Max 45 ICUMSA",
      granulation: "0.2-0.5 mm (fine)",
      sulphurDioxide: "Max 20 ppm"
    },
    packaging: "25kg bags, retail packs",
    shelfLife: "24 months",
    origin: "India",
    certifications: "FSSAI, ISO 22000"
  }
];

// Get all unique categories
export const sugarCategories = [...new Set(sugarData.map(s => s.category))];

// Get sugar by ID
export const getSugarById = (id) => sugarData.find(s => s.id === id);

// Get sugars by category
export const getSugarsByCategory = (category) => sugarData.filter(s => s.category === category);

// Category labels
export const sugarCategoryLabels = {
  refined: "Refined Sugar",
  raw: "Raw Sugar",
  plantation: "Plantation White",
  specialty: "Specialty Sugars",
  traditional: "Traditional/Jaggery"
};
